export const LOAD_FULL_PROFILE_START = 'LOAD_FULL_PROFILE_START';
export const LOAD_FULL_PROFILE_FINISHED = 'LOAD_FULL_PROFILE_FINISHED';
export const LOAD_FULL_PROFILE_FAILURE = 'LOAD_FULL_PROFILE_FAILURE';

export const USER_PROFILE_LOAD_START = 'USER_PROFILE_LOAD_START';
export const USER_PROFILE_LOAD_SUCCESS = 'USER_PROFILE_LOAD_SUCCESS';
export const USER_PROFILE_LOAD_FAILURE = 'USER_PROFILE_LOAD_FAILURE';

export const EDUCATION_HISTORY_LOAD_SUCCESS = 'EDUCATION_HISTORY_LOAD_SUCCESS';
export const WORK_HISTORY_LOAD_SUCCESS = 'WORK_HISTORY_LOAD_SUCCESS';
export const PROFILE_QUESTION_ANSWER_LOAD_SUCCESS = 'PROFILE_QUESTION_ANSWER_LOAD_SUCCESS';
export const CERTIFICATION_LOAD_SUCCESS = 'CERTIFICATION_LOAD_SUCCESS';
export const GEOGRAPHY_LOAD_SUCCESS = 'GEOGRAPHY_LOAD_SUCCESS';

export const LOAD_JOB_RECOMMENDATIONS_START = 'LOAD_JOB_RECOMMENDATIONS_START';
export const LOAD_JOB_RECOMMENDATIONS_SUCCESS = 'LOAD_JOB_RECOMMENDATIONS_SUCCESS';
export const LOAD_JOB_RECOMMENDATIONS_FAILURE = 'LOAD_JOB_RECOMMENDATIONS_FAILURE';

export const USER_PROFILE_NOTIFICATIONS_LOAD_SUCCESS = 'USER_PROFILE_NOTIFICATIONS_LOAD_SUCCESS';
export const USER_PROFILE_NOTIFICATIONS_LOAD_FAILURE = 'USER_PROFILE_NOTIFICATIONS_LOAD_FAILURE';

export const LOAD_HAS_APPLICATIONS_SUCCESS = 'LOAD_HAS_APPLICATIONS_SUCCESS';

export const USER_PROFILE_PARSE_RESUME_STATUS_LOAD_START =
  'USER_PROFILE_PARSE_RESUME_STATUS_LOAD_START';
export const USER_PROFILE_PARSE_RESUME_STATUS_LOAD_SUCCESS =
  'USER_PROFILE_PARSE_RESUME_STATUS_LOAD_SUCCESS';
export const USER_PROFILE_PARSE_RESUME_STATUS_LOAD_FAILURE =
  'USER_PROFILE_PARSE_RESUME_STATUS_LOAD_FAILURE';

export const PROFILE_QUESTION_ANSWERS_LOAD_START = 'PROFILE_QUESTION_ANSWERS_LOAD_START';
export const PROFILE_QUESTION_ANSWERS_LOAD_SUCCESS = 'PROFILE_QUESTION_ANSWERS_LOAD_SUCCESS';
export const PROFILE_QUESTION_ANSWERS_LOAD_FAILURE = 'PROFILE_QUESTION_ANSWERS_LOAD_FAILURE';
